import * as PIXI from "pixi.js";
import Main from "../Main";
import MiddleLayer from "../layers/MiddleLayer";
import TextureManager from "../managers/TextureManager";

const BOX_INSIDE_PATH = "./images/scene/box_inside.png";//984x890
const BOX_LINES_PATH = "./images/scene/box_lines.png"; //968x843

export default class BoxInside extends PIXI.Container {
  Main = Main.getInstance();
  MiddleLayer = MiddleLayer.getInstance();

  constructor() {
    super();

    this.addBoxInside();
    this.addBoxLines();
    this.addToLayer();
  }
  addBounds(spr: PIXI.Sprite) {
    const dim = this.Main.getDim();
    spr.anchor.set(.5);
    spr.x = dim.width / 2;
    spr.y = dim.height / 2;
    spr.width = 561;
    spr.height = 510;
  }
  generateSpr(path: string) {
    let texture = TextureManager.getTexture(path);
    const spr = new PIXI.Sprite(texture);
    this.addBounds(spr);
    this.addChild(spr);

    return spr;
  }
  addBoxInside() {
    const bInside = this.generateSpr(BOX_INSIDE_PATH);
    bInside.alpha = .8
  }
  addBoxLines() {
    this.generateSpr(BOX_LINES_PATH);
  }
  addToLayer() {
    this.MiddleLayer.addChild(this);
  }
}